import { LetterPressedHandlerObj } from "../types/List.js";
import {
  findFirstItemLabelStartsWithLetterKey,
  findNextItemLabelStartsWithKey,
  getSearchedKeyItemsCount,
} from "./listItemLabelUtils.js";

const listItemLabelStartsWithKeyFocus = (letterKey: string, items: Element[], letterKeyHandleObj: LetterPressedHandlerObj) => {
  const searchedKeyItemsCount = getSearchedKeyItemsCount(letterKey, items);
  const {
    setLastFoundPosition,
  } = letterKeyHandleObj;
  if (searchedKeyItemsCount > 0) {
    // updates key pressed state variables
    handleKeyPress(letterKey, letterKeyHandleObj);
    // obtain focus index for listItem element
    const elementFocusIndex = getFocusIndexForElementItem(letterKey, items, searchedKeyItemsCount, letterKeyHandleObj);
    // update searching position for next occurence
    setLastFoundPosition(elementFocusIndex);
    // focuses item with starting letter
    focusListItem(items[elementFocusIndex]);
  }
};

// updates pressed key variables for state
const handleKeyPress = (letterKey: string, letterKeyHandleObj: LetterPressedHandlerObj) => {
  const {
    getPressedKey, setPressedKey,
    getPressedCount, setPressedCount,
    setLastFoundPosition,
  } = letterKeyHandleObj;
  if (letterKey === getPressedKey()) {
    setPressedCount(getPressedCount() + 1);
  } else {
    setPressedKey(letterKey);
    setPressedCount(1);
    setLastFoundPosition(0);
  }
};

// obtains index for nextElement
const getFocusIndexForElementItem = (letterKey: string, items: Element[], searchedKeyItemsCount: number, letterKeyHandleObj: LetterPressedHandlerObj) => {
  const {
    getPressedCount, setPressedCount,
    getLastFoundPosition,
  } = letterKeyHandleObj;

  let focusIndex:number;

  if (getPressedCount() <= searchedKeyItemsCount) {
    // while in cycle for next item
    const startPosition = (getPressedCount() === 1 ? 0 : getLastFoundPosition() + 1);
    focusIndex = findItemLabelWithLetterIndex(letterKey, items, startPosition) + getLastFoundPosition();
    // move to next position
    if (getPressedCount() !== 1) {
      focusIndex += 1;
    }
  } else {
    // start again
    focusIndex = findItemLabelWithLetterIndex(letterKey, items);
    setPressedCount(1);
  }
  return focusIndex;
};

const focusListItem = (listItem: Element) => {
  (listItem as HTMLElement).focus();
};

const findItemLabelWithLetterIndex = (letterKey: string, items: Element[], startPosition = 0): number => {
  return startPosition === 0 ? findFirstItemLabelStartsWithLetterKey(letterKey, items) : findNextItemLabelStartsWithKey(letterKey, items, startPosition);
};

export default listItemLabelStartsWithKeyFocus;
